import { FC, Fragment, useState } from 'react';
import { FlightFilterModel } from 'ts/flight/classes/FlightFilterModel';
import FlightResultFilterSlider from './FlightResultFilterSlider';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { dateFormat } from 'utils/shared/utils';

interface FilterResultFilterTimeProps {
  filter: FlightFilterModel;
  setFilter: (filter: FlightFilterModel) => void;
}

const FilterResultFilterTime: FC<FilterResultFilterTimeProps> = ({ filter, setFilter }) => {
  const [isTakeOff, setIsTakeOff] = useState(true);
  const [urlParams] = useSearchParams();
  const [t] = useTranslation();

  return (
    <section className="flight-filter-section">
      <div className="text-bold mb-15">{t('filter.times')}</div>
      <div className="flight-filter-switcher">
        <span
          className={'flight-filter-switcher-btn' + (isTakeOff ? ' active' : '')}
          onClick={() => setIsTakeOff(true)}
        >
          {t('filter.takeoff')}
        </span>
        <span
          className={'flight-filter-switcher-btn' + (isTakeOff ? '' : ' active')}
          onClick={() => setIsTakeOff(false)}
        >
          {t('filter.landing')}
        </span>
      </div>
      {isTakeOff && (
        <Fragment>
          <div className="mb-10 text-sm">
            {t('filter.takeoff')} {t('from')}{' '}
            <span className="text-bold">{urlParams.get('departureCode')}</span>
          </div>
          {filter.departureOutboundTime && (
            <FlightResultFilterSlider
              filter={filter}
              setFilter={setFilter}
              minStr={dateFormat(filter.departureOutboundTime.value[0], 'EEE, dd MMM HH:mm')}
              maxStr={dateFormat(filter.departureOutboundTime.value[1], 'EEE, dd MMM HH:mm')}
              type="departureOutboundTime"
            />
          )}

          {filter.isInbound && filter.departureInboundTime && (
            <Fragment>
              <div className="mt-30 mb-10 text-sm">
                {t('filter.takeoff')} {t('from')}{' '}
                <span className="text-bold">{urlParams.get('arrivalCode')}</span>
              </div>
              <FlightResultFilterSlider
                filter={filter}
                setFilter={setFilter}
                minStr={dateFormat(filter.departureInboundTime.value[0], 'EEE, dd MMM HH:mm')}
                maxStr={dateFormat(filter.departureInboundTime.value[1], 'EEE, dd MMM HH:mm')}
                type="departureInboundTime"
              />
            </Fragment>
          )}
        </Fragment>
      )}
      {!isTakeOff && (
        <Fragment>
          <div className="mb-10 text-sm">
            {t('filter.landing')} {t('at')}{' '}
            <span className="text-bold">{urlParams.get('arrivalCode')}</span>
          </div>
          {filter.arrivalOutboundTime && (
            <FlightResultFilterSlider
              filter={filter}
              setFilter={setFilter}
              minStr={dateFormat(filter.arrivalOutboundTime.value[0], 'EEE, dd MMM HH:mm')}
              maxStr={dateFormat(filter.arrivalOutboundTime.value[1], 'EEE, dd MMM HH:mm')}
              type="arrivalOutboundTime"
            />
          )}

          {filter.isInbound && filter.departureInboundTime && filter.arrivalInboundTime && (
            <Fragment>
              <div className="mb-10 mt-30 text-sm">
                {t('filter.landing')} {t('at')}{' '}
                <span className="text-bold">{urlParams.get('departureCode')}</span>
              </div>
              <FlightResultFilterSlider
                filter={filter}
                setFilter={setFilter}
                minStr={dateFormat(filter.arrivalInboundTime.value[0], 'EEE, dd MMM HH:mm')}
                maxStr={dateFormat(filter.arrivalInboundTime.value[1], 'EEE, dd MMM HH:mm')}
                type="arrivalInboundTime"
              />
            </Fragment>
          )}
        </Fragment>
      )}
    </section>
  );
};

export default withErrorBoundary(FilterResultFilterTime, 'FilterResultFilterTime');
